import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-area-charts-page-ui',
    templateUrl: './bb-area-charts-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class BbAreaChartsPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
